import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const KnowledgeCenterIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(
  ({ size = 19, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={(+size * 16) / 19}
        viewBox="0 0 19 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.8962 1.20688C14.4506 1.21806 12.746 1.5255 11.5995 2.07331C10.4875 2.60459 9.89196 3.36372 9.63648 4.37224C9.56867 4.63998 9.32771 4.8275 9.05152 4.8275C8.77534 4.8275 8.53438 4.63998 8.46657 4.37224C8.21109 3.36372 7.61557 2.60459 6.50356 2.07331C5.35703 1.5255 3.6524 1.21806 1.20687 1.20687V12.0687C5.56246 12.0687 7.7016 12.8494 9.0516 14.1841C10.3969 12.8556 12.5388 12.0701 16.8849 12.0687C16.89 12.0554 16.8962 12.0319 16.8962 11.9959V1.20688ZM17.3573 0.0908255C17.2104 0.0302746 17.0529 -0.00059109 16.8939 8.57277e-06H16.8935C14.3783 0.011289 12.4632 0.323099 11.0792 0.984331C10.179 1.41441 9.50957 1.99022 9.05152 2.70443C8.59348 1.99022 7.924 1.41441 7.02383 0.984331C5.63985 0.323099 3.72474 0.011289 1.20959 8.57277e-06H1.20914C1.05021 -0.00059109 0.89271 0.0302746 0.745735 0.0908255C0.598761 0.15138 0.465214 0.240421 0.352823 0.352818C0.240435 0.465219 0.15139 0.598752 0.0908203 0.745722C0.0304756 0.892243 -0.000411987 1.04923 3.8147e-06 1.2077V12.0687C3.8147e-06 12.3888 0.12714 12.6958 0.353502 12.9221C0.579828 13.1484 0.886789 13.2756 1.20687 13.2756C5.96288 13.2756 7.59785 14.2347 8.58032 15.4628C8.69485 15.606 8.86831 15.6894 9.05167 15.6893C9.23504 15.6892 9.40842 15.6059 9.52292 15.4626C10.4987 14.2417 12.1405 13.2756 16.8962 13.2756C17.2602 13.2756 17.5787 13.1214 17.7971 12.8649C18.0079 12.6174 18.103 12.3031 18.103 11.9959V1.20782C18.1035 1.04931 18.0726 0.892281 18.0122 0.745722C17.9517 0.598752 17.8626 0.465219 17.7502 0.352818C17.6378 0.240421 17.5043 0.15138 17.3573 0.0908255Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.0543 3.62109C8.72106 3.62109 8.45087 3.89124 8.45087 4.22453V15.0864C8.45087 15.4196 8.72106 15.6898 9.0543 15.6898C9.38759 15.6898 9.65774 15.4196 9.65774 15.0864V4.22453C9.65774 3.89124 9.38759 3.62109 9.0543 3.62109Z"
          fill="currentColor"
        />
      </svg>
    )
  },
)

KnowledgeCenterIcon.displayName = 'KnowledgeCenterIcon'
